<template>
  <div>
    <px-view-header title="Minha empresa" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <v-card
      class="mx-auto rounded-card"
    >
      <v-card-text v-if="loading || loadingUpdateLogo">
        <px-circular-loading/>
      </v-card-text>
      <v-card-text v-if="!loading && !loadingUpdateLogo">
        <v-row dense>
          <v-col cols="12" sm="1" align="center" justify="center">
            <px-input-logo v-model="entidade.logo"
                           :public-file-path="publicFilePath"
                           :upload-path="uploadEntidadePath"
                           @uploaded-image="onUploadImageEntidade"/>
          </v-col>
          <v-col cols="12" sm="11" align="left" justify="left">
            <div class="d-flex align-center">
              <p class="headline font-weight-bold mb-1 text--primary pa-4">
                  {{ entidade.nome }} ({{ entidade.identificador }})
                <px-show-avaliacao-icon-simple class="ml-2"
                                               :avaliacao="entidade.pontuacaoMedia"/>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <px-minha-empresa-tabs v-if="entidade"
                           class="mt-3"
                           :entidade="entidade"
                           :public-file-path="publicFilePath"/>
  </div>
</template>

<script>
import EntidadeService from '@/api/entidade-service';
import MinhaEmpresaTabs from './tabs/MinhaEmpresaTabs.vue';

const publicFilePath = process.env.VUE_APP_PUBLIC_FILE_PATH;

export default {
  data() {
    return {
      loading: false,
      loadingUpdateLogo: false,
      entidade: null,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Minha empresa' },
      ],
      publicFilePath,
    };
  },
  computed: {
    uploadEntidadePath() {
      return `/comprador/files/public/${this.entidade.id}/entidade`;
    },
  },
  methods: {
    getEntidade() {
      this.loading = true;
      EntidadeService.getEntidade()
        .then(({ data }) => {
          this.entidade = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildPayloadEntidade(image) {
      return {
        id: this.entidade.id,
        logo: { ...image },
      };
    },
    onUploadImageEntidade(image) {
      this.loadingUpdateLogo = true;

      EntidadeService.updateLogoEntidade(this.buildPayloadEntidade(image))
        .then(() => {
          this.$toast('Logo da entidade atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loadingUpdateLogo = false;
        });
    },
  },
  created() {
    this.getEntidade();
  },
  components: {
    pxMinhaEmpresaTabs: MinhaEmpresaTabs,
  },
};
</script>
